module.exports = __webpack_public_path__ + "static/media/tenten_1010.5285b016.mp4";